import React from 'react'
import { StyleChatboxContainer, StyleMessageContainer } from './style'
import { useSelector } from 'react-redux'

import MessageHeader from './header'
import { MessageCircle } from 'lucide-react'
import { PlaceholderWrapper, PlaceholderText, IconWrapper } from './style'
import MessageLists from './lists'
import MessageInputField from './field'
import useIsMobile from '@hooks/useIsMobile'

const Messages = () => {
  const selectedChat = useSelector((state: any) => state.selectedChat)

  return (
    <StyleMessageContainer>
      {selectedChat ? (
        <StyleChatboxContainer>
          <MessageHeader />
          <MessageLists />
          <MessageInputField />
        </StyleChatboxContainer>
      ) : (
        <>
          <PlaceholderWrapper>
            <IconWrapper>
              <MessageCircle size={48} strokeWidth={1.5} />
            </IconWrapper>
            <PlaceholderText>
              Select a chat to start conversation
            </PlaceholderText>
          </PlaceholderWrapper>
        </>
      )}
    </StyleMessageContainer>
  )
}

export default Messages
